import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from '../dialogservice.service';
import { AgentsService } from '../utils/services/agents.service';
import { ProjectsService } from '../utils/services/projects.service';
import { AgentStatus } from '../utils/models/agent.model';
import { SharedService } from '../utils/services/shared.service';
import { KeycloakService } from 'keycloak-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-move-agent',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './move-agent.component.html',
  styleUrl: './move-agent.component.scss',
})
export class MoveAgentComponent {
  reasonToMove = '';
  feedback = '';
  @Input() data: any;
  projectsList: any[] = [];
  newProject = '';
  @Output() onAgentMove: EventEmitter<any> = new EventEmitter();
  isToShowError:boolean = false;

  partnerInfo: {
    email: string;
    partnerName: string;
    id: string;
  } = { email: '', partnerName: '', id: '' };
  isDisplayWarning: boolean = false;
  reasonToMoveInOtherProject: string = '';
  currentRole: string = '';
  currentUser: string = '';

  constructor(
    public dialogService: DialogService,
    public agentService: AgentsService,
    public projectsService: ProjectsService,
    public sharedService: SharedService,
    protected readonly keycloak: KeycloakService,
  ) {}

  ngOnInit() {
    console.log('data: ', this.data);
    
    // Initialize the project selection with the agent's project if available
    if (this.data.projectId) {
      this.newProject = this.data.projectId;
    }
    
    // Wir laden zuerst die Partner-Informationen und die Projektliste
    // und prüfen dann die Partner-Warnung, wenn beides geladen ist
    Promise.all([
      this.loadPartnerDetails(this.data.partnerId),
      this.loadProjectList()
    ]).then(() => {
      if (this.newProject && this.projectsList.length > 0) {
        this.onChangeProject();
      }
    })
    
    const tokenData = this.keycloak.getKeycloakInstance().tokenParsed;
    const userRoles = tokenData?.realm_access?.roles;
    this.currentUser = tokenData?.['email'];

    if (userRoles?.includes('Client')) {
      this.currentRole = 'Client';
    } else if (userRoles?.includes('Partner')) {
      this.currentRole = 'Partner';
    } else if (userRoles?.includes('Admin')) {
      this.currentRole = 'Admin';
    }
  }

  onClickArchiv() {
    if (this.reasonToMove != '') {
      const obj = {
        reason:
          this.reasonToMove !== 'Other' ? this.reasonToMove : this.feedback,
        AgentStatus: AgentStatus.ApplicantArchived,
      };
      this.agentService
        .archiveAgent(Number(this.data.id), obj)
        .subscribe(() => {
          this.dialogService.showMoveAgentDialog = false;
          if((this.data.status =="ApplicantGetsSuggested"||this.data.status =="AppointmentScheduled") && this.currentRole == 'Admin'){
            this.agentService.sendRejectionMail(this.data.emailAddress).subscribe(()=>{});
          }
          const text = `Mit Begründung ins Archiv verschieben ${this.reasonToMove !== 'Other' ? this.reasonToMove : this.feedback}`;
          this.feedback = '';
          this.reasonToMove = '';
          this.onAgentMove.emit();
          this.sharedService.logAgentMoment(this.data,this.currentUser,this.currentRole,text);
        });
    }
  }

  onClickMove() {
    if (this.newProject != '' && this.reasonToMoveInOtherProject != '') {
      this.isToShowError = false;
      this.agentService
        .agentMoveToOtherProject(Number(this.data.id), {
          projectId: this.newProject,
          reasonToMoveInOtherProject: this.reasonToMoveInOtherProject,
        })
        .subscribe((receivedAgent) => {
          this.dialogService.showMoveAgentDialog = false;
          const text = `Verschieben in ein anderes Projekt mit Grund ${this.reasonToMoveInOtherProject}`;
          this.newProject = '';
          this.reasonToMoveInOtherProject = '';
          this.onAgentMove.emit();
          this.sharedService.logAgentMoment(receivedAgent, this.currentUser, this.currentRole, text);
        });
    } else {
      this.isToShowError = true;
    }
  }

  // Lädt die Projektliste und gibt ein Promise zurück
  loadProjectList(): Promise<void> {
    return new Promise((resolve) => {
      this.projectsService.getAllProjects('', 'Admin').subscribe({
        next: (res: any) => {
          this.projectsList = res;
          console.log('Projektliste geladen:', this.projectsList.length);
          resolve();
        },
        error: (error) => {
          console.error('Error fetching projects: ', error);
          resolve();
        },
      });
    });
  }
  
  // Alte Methode für Abwärtskompatibilität
  getAllProjectList() {
    this.loadProjectList();
  }

  // Lädt Partner-Details und gibt ein Promise zurück
  loadPartnerDetails(partnerId: any): Promise<void> {
    return new Promise((resolve) => {
      if (!partnerId) {
        this.partnerInfo = { email: '', partnerName: '', id: '' };
        console.log('Kein Partner-ID vorhanden');
        resolve();
        return;
      }
      
      // Use the partner service to get partner information
      this.agentService.getPartnerInfo(partnerId).subscribe({
        next: (res: any) => {
          this.partnerInfo = { 
            email: res.email || '', 
            partnerName: res.partnerName || '', 
            id: partnerId 
          };
          console.log('Partner-Info geladen:', this.partnerInfo);
          resolve();
        },
        error: (err) => {
          console.error('Fehler beim Laden der Partner-Info:', err);
          this.partnerInfo = { email: '', partnerName: '', id: partnerId };
          resolve();
        }
      });
    });
  }
  
  // Alte Methode für Abwärtskompatibilität
  getPartnerDetails(partnerId: any) {
    this.loadPartnerDetails(partnerId);
  }

  onChangeProject() {
    const project = this.projectsList.find(
      (proj: any) => proj.id == this.newProject
    );
    
    if (!project) {
      console.error('Projekt nicht gefunden:', this.newProject);
      return;
    }
    
    // Wenn kein Partner-ID vorhanden ist, zeigen wir keine Warnung an
    if (!this.data.partnerId) {
      this.isDisplayWarning = false;
      return;
    }
    
    console.log('Prüfe Partner-Zuweisung:', {
      project: project,
      partnerId: this.data.partnerId,
      partnerName: this.partnerInfo.partnerName,
      partners: project.partners
    });
    
    // Prüfen, ob partners ein Array ist
    if (!Array.isArray(project.partners)) {
      console.error('partners ist kein Array:', project.partners);
      this.isDisplayWarning = true;
      return;
    }
    
    // Holen wir uns den Partner-Namen aus den Daten
    const partnerName = this.partnerInfo.partnerName || '';
    
    console.log('Partner-Name zum Vergleich:', partnerName);
    
    // Wenn der Partner-Name leer ist, zeigen wir keine Warnung an,
    // da die Partner-Informationen möglicherweise noch nicht geladen sind
    if (!partnerName) {
      console.warn('Partner-Name ist leer, keine Warnung anzeigen');
      this.isDisplayWarning = false;
      return;
    }
    
    // Prüfen, ob der Partner in der Liste der zugewiesenen Partner ist
    // Wir vergleichen den Partner-Namen, nicht die ID
    const isPartnerAssigned = project.partners.some((partner: any) => {
      // Partner kann ein String sein (direkt der Name)
      if (typeof partner === 'string') {
        return partner === partnerName;
      } 
      // Partner kann ein Objekt mit name oder partnerName Eigenschaft sein
      else if (partner && (partner.name || partner.partnerName)) {
        return (partner.name || partner.partnerName) === partnerName;
      }
      return false;
    });
    
    this.isDisplayWarning = !isPartnerAssigned;
    console.log('Partner zugewiesen:', isPartnerAssigned);
  }
}
